import AwsS3Multipart from "@uppy/aws-s3-multipart";
import Uppy from "@uppy/core";
import "@uppy/core/dist/style.css";
import Dashboard from "@uppy/dashboard";
import "@uppy/dashboard/dist/style.css";

export default function coverageItemImageUpload(el, props) {
  const imageUrlInput = el.querySelector("#coverage-item-image-url-input");

  const coverageItemImageUploader = Uppy({
    id: "coverage-item-image-uploader",
    autoProceed: true,
    allowMultipleUploads: false,
    restrictions: {
      allowedFileTypes: [".jpg", ".jpeg", ".png"],
      maxFileSize: 20 * 1024 * 1024, // 20 MB
      maxNumberOfFiles: 1,
    },
  });

  coverageItemImageUploader.use(Dashboard, {
    id: "coverage-item-image-dashboard",
    target: "#coverage-item-image-dashboard",
    inline: true,
    width: "100%",
    height: 400,
    thumbnailWidth: 280,
    doneButtonHandler: null, // Hide the 'Done' button, since clicking it removes the uploaded image
  });

  coverageItemImageUploader.use(AwsS3Multipart, {
    limit: 4,
    companionUrl: "/",
  });

  coverageItemImageUploader.on("upload-success", (file, response) => {
    imageUrlInput.value = response.uploadURL;
  });

  coverageItemImageUploader.on("upload-error", (file, error, response) => {
    console.log("error with file:", file.id);
    console.log("error message:", error);
  });
}
